import 'react-advanced-cropper/dist/style.css';

import {
    Badge,
    Box,
    Button,
    FileInput,
    Flex,
    Group,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    TagsInput,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';
import { useEffect, useRef, useState } from 'react';

import { Cropper } from 'react-advanced-cropper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { genericValidator } from '../../../../utils/validation';
import { isRequired } from 'mantine-form-rules';
import { objectToFormData } from '../../../../utils/formUtils';
import useAddMedia from '../../../../http/mutations/groups/useAddMedia';
import { useForm } from '@mantine/form';

const CreateMediaModal = ({ mediaGroup, existing, opened, close }) => {
    const [imageData, setImageData] = useState(null);

    const form = useForm({
        validateInputOnBlur: true,
        initialValues: {
            groupId: mediaGroup?.id,
            file: null,
            cropRect: {},
            tags: [],
        },

        validate: {
            file: isRequired('Image file is required'),
            cropRect: isRequired('Crop section is required'),
            /*emailOrUsername: isNotEmpty('Username or email is required'),
                password: (val) =>
                    val.length <= 6
                        ? 'Password should include at least 6 characters'
                        : null,*/

            trackingId: (value) => {
                const { type, message } = genericValidator(
                    'Tracking ID',
                    value,
                    {
                        required: false,
                        minLength: 4,
                        maxLength: 60,
                        pattern: /^[a-zA-Z0-9_-]+$/,
                    }
                );
                if (type) {
                    return type === 'pattern'
                        ? 'Tracking ID must only contain letters, numbers, hyphens and underscores'
                        : message;
                }
            },

            tags: (values) => {
                if (!values) {
                    return;
                }

                for (const value of values) {
                    const { type, message } = genericValidator('Tags', value, {
                        required: false,
                        minLength: 4,
                        maxLength: 60,
                        pattern: /^[a-zA-Z0-9_-]+$/,
                    });
                    if (type) {
                        return type === 'pattern'
                            ? 'Tags must only contain letters, numbers, hyphens and underscores'
                            : message;
                    }
                }
            },
        },
    });

    useEffect(() => {
        form.reset();
    }, [opened]);

    const { isPending, mutate: addOrUpdate } = useAddMedia();

    const onSubmit = (model) => {
        const formData = objectToFormData(model);
        addOrUpdate(formData, {
            onSuccess(data, variables, context) {
                close();
            },
            onError(error, variables, context) {
                // setError(error);
            },
        });
    };

    const handleFileLoad = (file) => {
        const reader = new FileReader();
        reader.onload = () => {
            setImageData(reader.result);
        };
        reader.readAsDataURL(file);

        //const blob = URL.createObjectURL(files[0]);*/

        // Get the image type from the extension. It's the simplest way, though be careful it can lead to an incorrect result:
        //setImageData(file);
    };

    const { onChange: fileInputOnChange, ...fileInputProps } =
        form.getInputProps('file');

    const onCropChange = (cropper) => {
        const coordinates = cropper.getCoordinates();
        form.setFieldValue('cropRect', coordinates);
    };

    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size={'md'}>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>
                        {existing ? 'Update' : 'Add'} Media
                    </Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={form.onSubmit(onSubmit)}>
                        <Stack gap={'xs'}>
                            <FileInput
                                label={'Media file'}
                                accept={'image/*'}
                                {...fileInputProps}
                                onChange={(file) => {
                                    handleFileLoad(file);
                                    fileInputOnChange(file);
                                }}
                            />
                            <Flex justify={'center'}>
                                <Cropper
                                    src={imageData}
                                    onChange={onCropChange}
                                    style={{ maxHeight: 300, width: '100%' }}
                                    zoomTo={0.5}
                                    backgroundWrapperProps={{
                                        scaleImage: false,
                                        moveImage: false,
                                    }}
                                    initialAspectRatio={1}
                                    viewMode={1}
                                    minCropBoxHeight={100}
                                    minCropBoxWidth={100}
                                    background={false}
                                    responsive={true}
                                    autoCropArea={1}
                                    checkOrientation={false}
                                    guides={true}
                                />
                            </Flex>

                            <TextInput
                                label={'Tracking ID'}
                                placeholder='Enter a tracking id'
                                {...form.getInputProps('trackingId')}
                            />

                            <TagsInput
                                label={'Tags'}
                                placeholder={'Tags'}
                                key={form.key('tags')}
                                {...form.getInputProps('tags')}
                            />

                            <Group justify='flex-end'>
                                <Button
                                    type={'submit'}
                                    disabled={isPending || !form.isValid()}
                                    rightSection={
                                        isPending ? (
                                            <FontAwesomeIcon
                                                icon={faSpinnerThird}
                                                spin
                                            />
                                        ) : null
                                    }>
                                    {existing ? 'Update' : 'Create'}
                                </Button>
                            </Group>
                        </Stack>
                    </form>
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default CreateMediaModal;
